import {
  composeSDKFactories,
  basePropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { CorvidTypes } from '@wix/editor-elements-types/corvid';
import type {
  IHamburgerMenuRootProps,
  IHamburgerMenuRootSDK,
} from '../HamburgerMenuRoot.props';
import type { IHamburgerOpenButtonSDK } from '../../HamburgerOpenButton/HamburgerOpenButton.types';

const _delegateSdkToHamburgerOpenButton: CorvidTypes.CorvidSDKFactory<
  IHamburgerMenuRootProps,
  IHamburgerOpenButtonSDK
> = ({ getChildren }) => {
  const [hamburgerOpenButtonSdk] = getChildren();
  return hamburgerOpenButtonSdk;
};

type BaseProps = ReturnType<typeof basePropsSDKFactory>;
type IHamburgerMenuRootOwnBaseProps = Omit<BaseProps, 'type' | 'scrollTo'>;

const _baseProps: CorvidTypes.CorvidSDKFactory<
  IHamburgerMenuRootProps,
  IHamburgerMenuRootOwnBaseProps
> = api => {
  // Excluding base props that should still point to the HamburgerOpenButton
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, scrollTo, ...hamburgerMenuRootBaseProps } =
    basePropsSDKFactory(api);

  return hamburgerMenuRootBaseProps;
};

export const _isMenuOpenSDK: CorvidTypes.CorvidSDKFactory<
  IHamburgerMenuRootProps,
  IHamburgerMenuRootSDK
> = api => {
  return {
    _getIsMenuOpen() {
      return api.props.isMenuOpen;
    },
    _setIsMenuOpen(isOpen: boolean) {
      api.setProps({ isMenuOpen: isOpen });
    },
  };
};

export const sdk = composeSDKFactories<
  IHamburgerMenuRootProps,
  IHamburgerOpenButtonSDK & IHamburgerMenuRootOwnBaseProps
>([_delegateSdkToHamburgerOpenButton, _baseProps, _isMenuOpenSDK]);

export default createComponentSDKModel(sdk);
